export const paths = {
  storeInsights: {
    root: "/insights",
    performance: "/insights/performance",
    comparison: "/insights/comparison",
    groupComparison: "/insights/group-comparison",
    fittingRoomsLiveView: "/insights/live/fitting-rooms",
  },
  reports: {
    sessions: "/reports/sessions",
    cantFind: "/reports/cant-find",
    missed: "/reports/missed",
    outOfStock: "/reports/out-of-stock",
    continuousReads: "/reports/continuous-reads",
    popularProducts: "/reports/popular-products",
    suspiciousActivity: "/reports/suspicious-activity",
    clickAndCollect: "/reports/click-and-collect",
  },
  admin: {
    commandCenter: "/admin/command-center",
    customers: "/admin/organization/customers",
    stores: "/admin/organization/stores",
    devices: "/admin/hardware/devices",
    rfidReaders: "/admin/hardware/rfid-readers",
    centralRfidActivity: "/admin/hardware/central-rfid-activity",
    etlRuns: "/admin/data/etl-runs",
    dataConsistency: "/admin/data/data-consistency",
    shopperDetails: "/admin/data/shopper-details",
    webhooks: "/admin/integrations/webhooks",
    apiKeys: "/admin/integrations/api-keys",
    sso: "/admin/integrations/sso",
    configs: "/admin/configuration/configs",
    mobileLinks: "/admin/configuration/mobile-links",
    categories: "/admin/configuration/categories",
    simulator: "/admin/development/simulator",
    inventory: "/admin/experimental/inventory",
    comparisonAnalytics: "/admin/experimental/comparison-analytics",
  },
  utilities: {
    userManagement: "/users",
    faq: "/faq",
    feedback: "/feedback",
    profile: "/profile",
  },
} as const;
